import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { HrParagraph, HrFlexContainer, HrButtons, HrTitleH3 } from '@components/styles/hr-styles';
import { Modal } from '../modal';
import useStore from '../../store/useStore';
import { DisplaySettingsContext } from '../../store/display-settings';

const Image = styled.figure`
  width: 136px;
  height: 136px;
  margin: 0;

  & img {
    width: 136px;
    height: 136px;
    object-fit: cover;
  }
`;

export const ConfirmExit = ({ setShowModal }) => {
  const { getDataPostulant } = useStore();
  const [t] = useTranslation();
  const { darkMode } = useContext(DisplaySettingsContext);

  return (
    <Modal setShowModal={setShowModal} width='360px'>
      <HrFlexContainer flexDirection='column' padding='32px' gap='32px'>
        <Image>
          <img src='/assets/img/question-circle-black.png' alt={t('postulant.modal.confirm_exit.img_alt')} />
        </Image>
        <HrFlexContainer justifyContent='center' gap='8px'>
          <HrTitleH3 color={darkMode ? 'white' : ''} textAlign='center'>{t('postulant.modal.confirm_exit.title')}</HrTitleH3>
          <HrParagraph color={darkMode ? 'white' : ''} textAlign='center'>{t('postulant.modal.confirm_exit.text')}</HrParagraph>
        </HrFlexContainer>
        <HrFlexContainer justifyContent='center' flexWrap='nowrap'>
          <HrButtons
            category='tertiaryGreenDark'
            size='medium'
            width='100%'
            onClick={() => {
              setShowModal(false);
            }}
          >
            {t('postulant.modal.confirm_exit.stay')}
          </HrButtons>
          <HrButtons
            category='primary'
            size='medium'
            width='100%'
            onClick={() => {
              window.location.href = getDataPostulant.portalLink;
            }}
          >
            {t('general.button.exit')}
          </HrButtons>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};
